module.exports = __webpack_public_path__ + "82d1f551a475aab1b2c37a861b87f411.svg";